import { getCookie } from "../../react/utils/cookies";
import runAfterPageLoad from "../runAfterPageLoad";

export default function orderRegistrationFields() {
  runAfterPageLoad(() => {
    const editButton = document.getElementById("edit_order");
    const saveButton = document.getElementById("save_order");
    if (!editButton || !saveButton) return;

    const container = document.getElementById("registration_field_container");
    const items = document.getElementsByClassName("registration_field_item");

    editButton.addEventListener("click", () => editOrder(container, items));
    saveButton.addEventListener("click", () => saveOrder(container, items));
  });
}

function editOrder(container, elemenets) {
  if (!container || elemenets.length < 1) return;

  $(container).sortable({
    axis: "y",
    cursor: "move",
    disabled: false,
    stop: () => changeOrder(elemenets),
  });

  $(container).disableSelection();
  modifyElementsCursor(elemenets, true);
}

function saveOrder(container, elements) {
  let registrationFields = [];
  const url = "/registration_fields/reorder";
  const method = "PATCH";

  Array.from(elements).forEach((el) => {
    const name = $(el).find("td")[0].innerText;
    const position = $(el).find("td")[4].innerText;

    registrationFields.push({ name: name, position: parseInt(position, 10) });
  });

  updateData(url, method, registrationFields);

  if ($(container).is(":ui-sortable")) {
    $(container).removeClass("ui-sortable");
    $(container).sortable({
      disabled: true,
    });

    modifyElementsCursor(elements, false);
  }
}

function changeOrder(elmenets) {
  Array.from(elmenets).forEach((el) => {
    $(el).find("td")[4].innerText = $(el).index() + 1;
  });
}

function modifyElementsCursor(elemenets, editable) {
  Array.from(elemenets).forEach((el) => {
    el.style.cursor = editable ? "pointer" : "auto";
  });
}

function updateData(url, method, registrationFields) {
  $.ajax({
    url: url,
    method: method,
    headers: {
      AuthorizationUserToken: getCookie("user_token") ?? null,
    },
    contentType: "application/json",
    data: JSON.stringify(registrationFields),
    error: function () {
      alert("Error occured while trying to update fields");
    },
  });
}
